import SelectHotelForm from "@/components/form/SelectHotelForm";

const RegisterPage = () => {
  return <SelectHotelForm />;
};

export default RegisterPage;
